const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
// const DEFAULT_PAGE = () => import('@/layout/page.vue');

const PROCEEDS = {
  path: '/hy-leads',
  name: 'hy-leads',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'hy-leads-list' },
  meta: {
    title: '底层标的',
    requiresAuth: true,
    hideChildrenInMenu: true,
    // icon: 'icon-file ',
    roles: 'hy-leads',
    order: 123
  },
  children: [
    {
      path: '',
      name: 'hy-leads-list',
      component: () => import('@/views/sys-obj/sys-obj.vue'),
      props: { entity: 1 },
      meta: {
        requiresAuth: true,
        title: '底层标的'
      }
    }
  ]
};

export default PROCEEDS;
